<script>
import { reactive } from 'vue'
import { getSize } from '@/lib/common'
import csImage from '@/components/cs-image.vue'

export default {
  components: {
    csImage
  },
  props: {
    fullPath: {
      type: String,
      required: true
    },
    caption: {
      type: String,
      default: ''
    },
    tag: {
      type: String,
      default: 'div'
    }
  },
  setup (props) {
    return reactive({
      metadata: {}
    })
  },
  computed: {
    fileName () {
      return this.metadata.customMetadata
        ? this.metadata.customMetadata.fileName
        : ''
    },
    size () {
      return getSize(this.metadata.size || 0)
    }
  }
}
</script>

<template>
  <component
    :is="tag"
    class="image-viewer"
  >
    <cs-image
      :fullPath="fullPath"
      :caption="caption"
      @getMetadata="metadata = $event"
    />
    <div>
      <ul>
        <li class="is-size-6">{{ fileName }}</li>
        <li class="is-size-6">{{ size }}</li>
      </ul>
      <slot></slot>
    </div>
  </component>
</template>

<style lang="scss" scoped>
.image-viewer {
  position: relative;
}
</style>
